// action type constants
export const OPEN_DRAWER = 'OPEN_DRAWER';
export const CLOSE_DRAWER = 'CLOSE_DRAWER';

// actionCreators
export const openDrawer = ({ type, content }) => ({ type: OPEN_DRAWER, payload: { type, content } });
export const closeDrawer = () => ({ type: CLOSE_DRAWER });

export const getDrawer = (state) => state.infodrawer;

const initialState = {
  open: false,
  type: '',
  content: null,
};

// reducer
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case OPEN_DRAWER:
      return { ...state, open: true, type: payload.type, content: payload.content };
    case CLOSE_DRAWER:
      return initialState;
    default:
      return state;
  }
};
